<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="newbookingData.customerName" matInput (keyup)="searchCustomerName($event)" [matAutocomplete]="auto">
        <button
      mat-button
      *ngIf="loaderForAutocomplete"
      matSuffix
      mat-icon-button
      aria-label="Clear"
    >
    <mat-progress-spinner
    diameter="20"
    mode="indeterminate"
    color="accent"
    strokeWidth="3"
    style="width: 20px; height: 20px;"
  > </mat-progress-spinner>
    </button>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option
            *ngFor="let item of autocompleteItems"
            (click)="selectSearchResult(item)"
          >
            {{ item.name | titlecase }} ({{item.country_code}} {{item.phone}})
          </mat-option>
        </mat-autocomplete>
       
      </mat-form-field>
    </div>
    <!-- <div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Phone</mat-label>
          <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
          maxlength="10"/>
          
        </mat-form-field>
      </div> -->
    <div class="row g-2 justify-content-between phone-field">
      <mat-form-field appearance="outline" class="country-code col-3">
        <mat-label>Country Code</mat-label>
        <mat-select
        [(ngModel)]="selectedCountryCode"
        required
        (selectionChange)="onCountrySelected($event)"
      >
        <mat-select-trigger>
          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
              {{ "(" + selectedCountryCode.dial_code + ")" }}
        </mat-select-trigger>
        
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="no results found"
            name="countrysearch"
            placeholderLabel="Enter country name"
            [formControl]="searchString"
            (keyup)="onKey()"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let country of countryList" [value]="country">
          {{ country.flag }} {{ country.name }}
          {{ "(" + country.dial_code + ")" }}
        </mat-option>
      </mat-select>
      </mat-form-field>
      <mat-form-field class="mobile_form col-9" appearance="outline">
        <mat-label>Phone</mat-label>
        <input
          [(ngModel)]="newbookingData.customerPh"
          matInput
          type="tel"
          smNumericOnly
          minLength="3"
                  maxlength="17"
        />
        <mat-hint
          style="color: red; font-size: 13px"
          align="end"
          *ngIf="
            newbookingData.customerPh &&
            newbookingData.customerPh != '' &&
            newbookingData.customerPh.length < 3
          "
          >Please enter a valid phone number in the range of 3-17.</mat-hint
        >
      </mat-form-field>
        <mat-form-field class="mobile_form col-9" appearance="outline">
        <mat-label>Email</mat-label>
        <input
          [(ngModel)]="newbookingData.email"
          matInput
          />
       
      </mat-form-field>
    </div>

    

 <h3 class="servicet_heading">Service type</h3>
  <div class="form-group service-button" style=" border-bottom: 1px solid lightgray; padding-bottom: 12px;  margin-top: 10px;">
    <mat-chip-list class="example-chip">
        <mat-chip *ngIf="shop_status != 2 && ssa == '1'" [ngClass]="{ 'selected': selectedServiceType == '1' }" (click)="changeServiceType('1')">In-premise service</mat-chip>
        <mat-chip *ngIf="home_status != 2 && hsa =='1'" [ngClass]="{ 'selected': selectedServiceType == '0' }" (click)="changeServiceType('0')">Home service</mat-chip>
        <mat-chip *ngIf="virtual_status != 2 && vsa == '1'" [ngClass]="{ 'selected': selectedServiceType == '2' }" (click)="changeServiceType('2')">Virtual service</mat-chip>
    </mat-chip-list>
</div>

<h3 class="servicet_heading" style="margin-bottom: 16px;" *ngIf="isEntityIndividual == '1'">Day and time</h3>
<div *ngIf="isEntityIndividual == '1'">
  <div class="chip_cont" *ngFor="let item of selectedDays; let i = index">
  <mat-chip-list aria-label="Fish selection" class="mb-3 matchp" style="border-bottom: 1px solid #e2e2e2;padding-bottom: 15px;width: 100%;display: block;" >
     <div class="close_heradinrt">
      <p style="cursor: pointer;" (click)="removeSelectedDay(i)">Remove</p>
   </div>
      <div>
        <mat-chip
        class="selected"
          style="height: auto">{{ item.day.dayName }}
        </mat-chip>
        <mat-chip
        class="selected"
          style="height: auto"
          
          >{{ tConv24(item.startTime) }} - {{tConv24(item.endTime)}}
        </mat-chip>
      </div>
    </mat-chip-list>
  </div>
  
  <button
  class="add-new-btn"
  (click)="openTimings()"
  mat-flat-button
  color="accent">
<mat-icon>add</mat-icon>
  Add another day
</button>

</div>
  <!-- SERVICES -->

    <h3 class="servicet_heading"> {{ selectedServiceType == "1" ? "In-premise services" : (selectedServiceType == '0' ? 'Home services' : "Virtual services") }}</h3>
    <div class="chip_cont" style="padding: 20px 0px">
      <mat-chip-list class="example-chip" *ngIf="serviceList.length > 0">
        <div *ngFor="let item of serviceList">
          <mat-chip
            *ngIf="item.toShow"
            style="height: auto"
            (click)="selectServices(item)"
            >{{ item.serviceName }}
          </mat-chip>
        </div>
      </mat-chip-list>
      <p *ngIf="serviceList.length == 0" style="color: #a6a6a6;">No service added</p>
    </div>

    <!-- PRODUCTS -->
    <h3 class="servicet_heading" *ngIf="productsList.length > 0">Sellable products</h3>
    <div class="chip_cont" style="padding: 20px 0px" *ngIf="productsList.length > 0">
      <mat-chip-list class="example-chip" *ngIf="productsList.length > 0">
        <div *ngFor="let item of productsList">
          <mat-chip
            *ngIf="item.toShow"
            style="height: auto"
            (click)="selectProducts(item)"
            >{{ item.product_name }}
          </mat-chip>
        </div>
      </mat-chip-list>
      <p *ngIf="productsList.length == 0" style="color: #a6a6a6;">No product added</p>
    </div>

    <!-- SELECTED JOBS -->

    <h3 *ngIf="selectedJobs.length > 0">Job selected</h3>
    <div class="" *ngIf="selectedJobs.length > 0">
      
      <div *ngFor="let item of selectedJobs; let i = index;">
        <div
          
          style="
            display: inline-block;
            width: fit-content;
            background: #ffc107;
            padding: 8px 20px;
            border-radius: 34px;
            margin-bottom: 20px;
          "
        >
          <p style="margin: 0px; font-weight: 500; font-size: 16px">
            {{ item.serviceName }}
          </p>
        </div>
        <mat-icon style="    font-size: 20px;
        font-weight: 900;
        color: #000;
        position: relative;
        top: 4px;
        margin-left: 10px;">close</mat-icon>
        <div style="display: inline-block;">
          <span style="    margin-left: 10px;
          border: 1px solid #a2a2a2;
          padding: 10px;
          border-radius: 10px;">
            <button
            (click)="decreaseServiceCount(item,i)"
            style="background: none;
            border: 1px solid #a2a2a2;
            border-radius: 25px;
            width: 25px;
            height: 25px;">
            <mat-icon class="material-icons-outlined" style="    font-size: 16px;
            position: relative;
            top: 2px;
            left: -3px;
            color: #666666;
            height: auto;
            width: auto;">remove</mat-icon>
            </button>
            <span style="    margin: 0 15px;"> {{item.selectedCount}} </span>
            <button 
            (click)="increaseServiceCount(item,i)"
            style="background: none;
            border: 1px solid #a2a2a2;
            border-radius: 25px;
            width: 25px;
            height: 25px;">
            <mat-icon style="    font-size: 16px;
            position: relative;
            top: 2px;
            left: -3px;
            color: #666666;
            height: auto;
            width: auto;" class="material-icons-outlined">add</mat-icon>
            </button>
          </span>
          <span
          (click)="removeSelectedJobs(item)"
          style="text-decoration: underline;
          margin-left: 20px;
          display: inline-block;
          cursor: pointer;">
            Remove
          </span>
        </div>
      </div>
    </div>

<!-- SELECTED PRODUCTS -->

    <h3 *ngIf="selectedProducts.length > 0">Products selected</h3>
    <div class="" *ngIf="selectedProducts.length > 0">
      
      <div *ngFor="let item of selectedProducts; let i = index;">
        <div
          
          style="
            display: inline-block;
            width: fit-content;
            background: #ffc107;
            padding: 8px 20px;
            border-radius: 34px;
            margin-bottom: 20px;
          "
        >
          <p style="margin: 0px; font-weight: 500; font-size: 16px">
            {{ item.product_name }}
          </p>
        </div>
        <mat-icon style="    font-size: 20px;
        font-weight: 900;
        color: #000;
        position: relative;
        top: 4px;
        margin-left: 10px;">close</mat-icon>
        <div style="display: inline-block;">
          <span style="    margin-left: 10px;
          border: 1px solid #a2a2a2;
          padding: 10px;
          border-radius: 10px;">
            <button
            (click)="decreaseProductCount(item,i)"
            style="background: none;
            border: 1px solid #a2a2a2;
            border-radius: 25px;
            width: 25px;
            height: 25px;">
            <mat-icon class="material-icons-outlined" style="    font-size: 16px;
            position: relative;
            top: 2px;
            left: -3px;
            color: #666666;
            height: auto;
            width: auto;">remove</mat-icon>
            </button>
            <span style="    margin: 0 15px;"> {{item.selectedCount}} </span>
            <button 
            (click)="increaseProductCount(item,i)"
            style="background: none;
            border: 1px solid #a2a2a2;
            border-radius: 25px;
            width: 25px;
            height: 25px;">
            <mat-icon style="    font-size: 16px;
            position: relative;
            top: 2px;
            left: -3px;
            color: #666666;
            height: auto;
            width: auto;" class="material-icons-outlined">add</mat-icon>
            </button>
          </span>
          <span
          (click)="removeSelectedProducts(item)"
          style="text-decoration: underline;
          margin-left: 20px;
          display: inline-block;
          cursor: pointer;">
            Remove
          </span>
        </div>
      </div>
    </div>
 

   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>
    </div>


    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row" style="width: 100%;">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="plus_tht" style="padding-top: 14px;">
                <mat-icon class="serv_x">close</mat-icon>
                <div class="inc_dec_cont">
                  <span class="cont_span">
                    <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                  
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <!-- <mat-form-field appearance="outline">
                <mat-select [(value)]="selectedSlab" [(ngModel)]="selectedSlab" class="w-100">
                            <mat-option value="default" >
                              Select a tax
                            </mat-option>
                            <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                              {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                            </mat-option>
                           
                          </mat-select>
             </mat-form-field> -->
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                            <mat-option value="default" >
                              Select a tax
                            </mat-option>
                            <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                              {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                            </mat-option>
                           
                          </mat-select>
             </mat-form-field>
            </div>
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item price</mat-label>
                  <input matInput formControlName="price" type="text" placeholder="Enter item price" smDecimalOnly type="number">
                </mat-form-field>
              </div>
            </div>
            <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->




    <!-- <h3>Current status</h3>
    <div class="chip_cont" style="padding: 10px 0px 20px;">
      <mat-chip-list aria-label="Fish selection" class="mb-3">
        <div >
          <mat-chip
            [ngClass]="{'selected': requestStatus == '1'}"
            style="height: auto"
            (click)="changerequestStatus(1)"
            >New query
          </mat-chip>
        </div>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3">
        <div >
          <mat-chip
          [ngClass]="{'selected': requestStatus == '3'}"
            style="height: auto"
            (click)="changerequestStatus(3)"
            >Enrollment
          </mat-chip>
        </div>
      </mat-chip-list>
    </div> -->


    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Cost</mat-label>
        <input
          [(ngModel)]="newbookingData.price"
          matInput
          smDecimalOnly type="number"
          [disabled]="true"
        />
        
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Notes</mat-label>
        <textarea [(ngModel)]="newbookingData.note" [maxLength]="400" matInput></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close
  
    >
      Cancel
    </button>
    <button
      
      mat-flat-button
      color="accent"
      [disabled]=" formChecker() || !newbookingData.customerName"
      (click)="onPost()"
      
    >
    Confirm
    </button>

  </mat-dialog-actions>
  